import React, { FC, useState } from "react";
import { observer } from "mobx-react";
import { NotificationsOutlined } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";

import { useStores } from "../../hooks/useStores.hook";
import { NotificationsModal } from "../modals/NotificationsModal";
import { Snackbar } from "../Snackbar";

export const NotificationMenu: FC<{}> = observer(() => {
  const { notificationStore } = useStores();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Snackbar />
      <NotificationsModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <IconButton sx={{ position: "fixed", bottom: 16, left: 16, zIndex: 100 }} onClick={() => setIsOpen(!isOpen)}>
        <Badge badgeContent={notificationStore.notificationCount} color="primary">
          <NotificationsOutlined color="primary" />
        </Badge>
      </IconButton>
    </>
  );
});
